import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-white py-20" aria-labelledby="faq-title" data-id="element-61" data-mp="1he2wzy8t5mf4">
      <div className="mx-auto max-w-3xl px-4" data-id="element-62" data-mp="1cf9nsi0k0hkr">
        <p className="mb-3 text-center text-xs font-extrabold uppercase tracking-[.18em] text-teal" data-id="element-63" data-mp="1ccdp2rgvtov9">Resolvemos tus dudas</p>
        <h2 id="faq-title" className="text-balance text-center text-3xl font-extrabold text-ink md:text-4xl" data-id="element-64" data-mp="253f6z0bylyih">Preguntas frecuentes</h2>
        <div className="mt-10 space-y-3" data-id="element-65" data-mp="2031amfjq0d0a">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className="overflow-hidden rounded-2xl border border-line bg-mist" data-id="element-66" data-mp="oonrfnzwwlql" data-mpi={index}>
                <h3 data-id="element-67" data-mp="jpb1uvhnp0kb">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-ink focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/45 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-68" data-mp="jorn1nnaysai">
                    <span data-id="element-69" data-mp="1fnuepis9tqmv">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-teal transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-70" data-mp="1fmsryh1w7fpb" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-71" data-mp="s0dyvfm6zoct">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-72" data-mp="wz7b74pqt9be">
                      <p className="border-t border-line px-5 py-4 leading-relaxed text-muted sm:px-6" data-id="element-73" data-mp="2pneyh1um1jns">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}